import dayjs from "dayjs";

export const MEMBERS = [
    { telegramId: 376964008, id: 2, name: "Андрій Нежид", defaultWarehouseId: 4, email: 'andriinezhyd@gmail.com', role: "admin" },
    { telegramId: 987654321, id: 3, name: "Test Test", defaultWarehouseId: 1, email: 'test2233@gmail.com', role: "finance" },
    { telegramId: 111111111, id: 4, name: "Ірина Нежид", defaultWarehouseId: 4, email: 'irushanezhyd@gmail.com', role: "admin" },
    { telegramId: 222222222, id: 5, name: "Ліка Ріц", defaultWarehouseId: 1, email: 'ritzlika@gmail.com', role: "manager" },
    { telegramId: 333333333, id: 6, name: "Анна Каменева", defaultWarehouseId: 1, email: 'annykameneva@gmail.com', role: "manager" },
    { telegramId: 384274264, id: 7, name: "Анна Смирнова", defaultWarehouseId: 1, email: 'smirnova1ls5smirnova@gmail.com', role: "director" },
    { telegramId: 666666666, id: 11, name: "Кристина Шляхова", defaultWarehouseId: 1, email: 'kristinashlyahova981@gmail.com', role: "finance" },
    { telegramId: 777777777, id: 13, name: "Карина Светличная", defaultWarehouseId: 1, email: 'karina.svetli08@gmail.com', role: "manager" },
    // { telegramId: 888888888, id: 15, name: "Єлизавета Тимчук", defaultWarehouseId: 4, email: 'elza.tymchuk@gmail.com', role: "ROP" },
    { telegramId: 999999999, id: 16, name: "Єлизавета Савченко", defaultWarehouseId: 1, email: 'lizatokareva09@gmail.com', role: "manager" },
    // { telegramId: 101010101, id: 17, name: "Дмитро Коток", defaultWarehouseId: 3, email: 'mitia.kotok33@gmail.com', role: "manager" },
    { telegramId: 121212121, id: 18, name: "Владислав Костін", defaultWarehouseId: 3, email: 'vladkostin110205@gmail.com', role: "manager" },
    // { telegramId: 0, id: 18, name: "Євгенія Маковецька", defaultWarehouseId: 3, email: 'yevheniia.makivka@gmail.com', role: "manager" }
];

export const TIMEZONE = "Europe/Kiev"

export const STATUS_OPTIONS = [
    { status_group_id: 1, label: "Новий" },
    { status_group_id: 2, label: "Погодження" },
    { status_group_id: 3, label: "Виробництво" },
    { status_group_id: 4, label: "Доставка" },
    { status_group_id: 5, label: "Виконано" },
    { status_group_id: 6, label: "Відмінено" },
];

export const SOURCE_OPTIONS = [
    { id: [1, 4], label: "Instagram" },
    { id: [2], label: "Telegram" },
    { id: [9], label: "Site" },
    { id: [10], label: "Showroom" },
];

export const FILTER_PRESETS = [
    {
        label: "PR+",
        sources: [1,9,10],
        statuses: [1,3,4,5,6],
        selectedManagers: [],
        tagFilterMode: "no_both",
        rangeDate: "day",
        // fetchLiveToday: true,
        range: {
            startDate: dayjs().startOf("month").toDate(),
            endDate: dayjs().endOf("month").toDate()
        }
    },
    {
        label: "Опт",
        sources: [],
        statuses: [],
        selectedManagers: [],
        tagFilterMode: "only_opt",
        rangeDate: "day",
        range: {
            startDate: dayjs().startOf("month").toDate(),
            endDate: dayjs().endOf("month").toDate()
        }
    },
    {
        label: "Бартери",
        sources: [],
        statuses: [],
        selectedManagers: [],
        tagFilterMode: "only_barter",
        rangeDate: "day",
        range: {
            startDate: dayjs().startOf("month").toDate(),
            endDate: dayjs().endOf("month").toDate()
        }
    },
    {
        label: "Загальні",
        sources: [],
        statuses: [1,3,4,5],
        selectedManagers: [],
        tagFilterMode: "no_barter",
        rangeDate: "day",
        fetchLiveToday: true,
        range: {
            startDate: dayjs().startOf("month").toDate(),
            endDate: dayjs().endOf("month").toDate()
        }
    },
    {
        label: "ОП",
        sources: [1,2,4],
        statuses: [1,3,4,5,6],
        selectedManagers: [5,6,11],
        tagFilterMode: "no_both",
        rangeDate: "day",
        fetchLiveToday: true,
        range: {
            startDate: dayjs().startOf("month").toDate(),
            endDate: dayjs().endOf("month").toDate()
        }
    },
];

export const BOT_TOKEN = "bot5346603542:AAFy1TKplf7w8EG2rdVigK-DvXTTjEjWDtg";
export const CHAT_ID_TEST = "@lava_expenses";
export const CHAT_ID_PR = "-1001629241497"; // PR +
export const CHAT_ID_AT = "-5014525377"; // AndreyTitenko1

export const ARR_RANGES = ["day", "week", "2weeks", "month", "year"];

export const CATEGORIES = {
    business: [
        "NovaPay",
        "Таргетолог",
        "Блогери",
        "Внутрішні перекази",
        "Вода",
        "Закупка Ткань",
        "Закупка Фурнітури",
        "Зйомки",
        "ЗП",
        "Виробництво",
        "Дивіденди",
        "Інвестиція",
        "Інше",
        "Корпоративна культура",
        "Надходження",
        "Нова Пошта",
        "Пакування",
        "Податки",
        "Повернення",
        "Пошив",
        "Програми",
        "Реклама",
        "Ремонт",
        "Робота з тканиною",
        "Шоурум Київ",
        "Шоурум Харків",
        // 🟨 комиссии
        "Комісія Monobank сайт",
        "Комісія Monobank шоурум",
    ],
    personal: [
        "Автомобіль",
        "Внутрішні перекази",
        "Вода",
        "Досуг",
        "Краса",
        "Лестер",
        "Лікування/Аптека",
        "Надходження",
        "Інше",
        "Кафе/Ресторан",
        "Інтернет/телефон",
        "Нова пошта",
        "Одяг",
        "Оренда/комунальні",
        "Підписка",
        "Продукти",
        "Подарунки",
        "Подорожі",
        "Покупки техники",
        "Ремонт",
        "Спорт",
        "Таксі",
    ],
    cash: [
        "NovaPay",
        "PR+",
        "Блогери",
        "Внутрішні перекази",
        "Закупка Ткань",
        "Закупка Фурнітури",
        "Зйомки",
        "ЗП",
        "Інше",
        "Корпоративна культура",
        "Надходження",
        "Пакування",
        "Повернення",
        "Пошив",
        "Програми",
        "Реклама",
        "Ремонт",
        "Робота з тканиною",
        "Шоурум Київ",
        "Шоурум Харків",
        "Автомобіль",
        "Внутрішні перекази",
        "Вода",
        "Надходження",
        "Інше",
        "Кафе",
        "Одяг",
        "Оренда/комунальні",
        "Лестер",
        "Підписка",
        "Подарунки",
        "Подорожі",
        "Ремонт",
        "Спорт",
    ]
};

export const ALLOWEDSTATUSIDS = [
    1, 35, 6, 8, 9, 10, 11, 22, 26,
    12, 30, 31, 32, 33, 34, 20, 21, 39
];

/** У Обігу: чорна картка лише за кнопкою admin. eAid / madeInUkraine не показуємо. */
export const ADMIN_ONLY_CARDS = ["black"];

export const HIDDEN_CATEGORIES_FOR_NON_ADMIN = [
    "ЗП",
    "Дивіденди",
    // "Виплати власнику",
];

export const FB_ACCOUNTS = {
    lava1: "321158760644871",     // #1
    lava2: "819423623190756",     // #2
    lava3: "380135854836507",     // #3
    lava4: "1492415371853374",     // #4
};

export const ACCOUNTS = [
    { key: "lava1", label: "Lava Studio #1" },
    { key: "lava2", label: "Lava Studio #2" },
    { key: "lava3", label: "Lava Studio #3" },
    { key: "lava4", label: "Lava Studio #4" },
];

/** Групи графіку змін, які завжди є в підказках, навіть коли в них зараз нікого немає. */
export const SCHEDULE_GROUP_PRESETS = ["Шоурум Харків"];
